import React from "react"
import PropTypes from "prop-types"

//i18n
import { withTranslation } from "react-i18next"

import { PageContent, CustomBreadcrumb } from "components/Common"
import Profiles from "./Profiles"
import { ModuleIds } from "constant"

const RESOURCE = ModuleIds.Profile

const ProfilesContainer = ({ t }) => {
  const titleTag = t(`Profile`)
  return (
    <PageContent title={titleTag}>
      {/* PageTitle */}
      <CustomBreadcrumb
        breadcrumbItem={t("Profile List")}
        resource={RESOURCE}
      />

      {/* Page Body */}
      <Profiles />
    </PageContent>
  )
}

ProfilesContainer.propTypes = {
  t: PropTypes.any,
}

export default withTranslation(["profilePage"])(ProfilesContainer)
